import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ActionTypes } from 'src/types/stores/drawer'
import { computed } from 'vue'
import { useDrawerStore } from 'src/stores/modules/drawer'


import { defineComponent } from 'vue'
const __default__ = defineComponent({ name: 'DrawerToggleButton' })

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useDrawerStore()
const title = computed(() => (store.open ? 'Chiudi Menu' : 'Apri Menu'))

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    dense: "",
    flat: "",
    round: "",
    icon: "mdi-menu",
    onClick: _unref(store)[_unref(ActionTypes).TOGGLE_OPEN]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tooltip, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(title.value), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClick"]))
}
}

})